import { Type } from '@sinclair/typebox';
import type { Static } from '@sinclair/typebox';

/**
 * Схема события стрима LLM
 * Используется для типизации сообщений, отправляемых через llmStreamChannel
 */
export const LlmStreamEventSchema = Type.Object({
  type: Type.Literal('stream_event'),
  streamType: Type.Union([
    Type.Literal('stream_start'),
    Type.Literal('stream_chunk'),
    Type.Literal('stream_done'),
    Type.Literal('stream_error'),
    Type.Literal('stream_cancelled'),
    Type.Literal('iteration_start'),
    Type.Literal('iteration_done'),
    Type.Literal('tool_requires_user_input'),
  ]),
  sessionId: Type.String(),
  chunk: Type.Optional(Type.String()),
  audioChunk: Type.Optional(Type.String()),
  chunkIndex: Type.Optional(Type.Number()),
  metadata: Type.Optional(
    Type.Object({
      model: Type.Optional(Type.String()),
      processing_time_ms: Type.Optional(Type.Number()),
      total_chunks: Type.Optional(Type.Number()),
      error: Type.Optional(Type.String()),
      audioFormat: Type.Optional(Type.String()),
      toolCall: Type.Optional(
        Type.Object({
          name: Type.Optional(Type.String()),
          call_id: Type.Optional(Type.String()),
          status: Type.Optional(
            Type.Union([
              Type.Literal('pending'),
              Type.Literal('executing'),
              Type.Literal('completed'),
              Type.Literal('error'),
              Type.Literal('waiting_user_input'),
            ])
          ),
          prompt: Type.Optional(Type.String()),
        })
      ),
      iteration: Type.Optional(Type.Number()),
    })
  ),
  timestamp: Type.String({ format: 'date-time' }),
});

export type LlmStreamEvent = Static<typeof LlmStreamEventSchema>;
